"use client";

import React, { createContext, use } from "react";
import { Button, Collapsible, useCollapsible } from "@chakra-ui/react";

// Sub-menus are nested Collapsibles, so links can't reach the outer menu
// through useCollapsibleContext.
const CloseMobileNavContext = createContext<() => void>(() => {});

// We currently need to have a separate Context because ark doesn't provide a CloseTrigger
// https://github.com/chakra-ui/ark/discussions/4025
export function MobileNavRoot({ children }: { children: React.ReactNode }) {
  const collapsible = useCollapsible();

  return (
    <Collapsible.RootProvider value={collapsible}>
      <CloseMobileNavContext value={() => collapsible.setOpen(false)}>
        {children}
      </CloseMobileNavContext>
    </Collapsible.RootProvider>
  );
}

export function MobileNavButton(props: React.ComponentProps<typeof Button>) {
  return (
    <Button
      variant="ghost"
      size="sm"
      px={2}
      // Optically align leading edge of text
      mx={-2}
      justifyContent="flex-start"
      {...props}
    />
  );
}

export function MobileNavLink({ children }: { children: React.ReactNode }) {
  const closeMobileNav = use(CloseMobileNavContext);

  return (
    <MobileNavButton asChild onClick={closeMobileNav}>
      {children}
    </MobileNavButton>
  );
}
